import { ACTION, ACTION_SUBJECT, ACTION_SUBJECT_ID, EVENT_TYPE } from '@atlaskit/editor-common/analytics';
export var getMediaResizeAnalyticsEvent = function getMediaResizeAnalyticsEvent(type, attributes) {
  if (!attributes) {
    return;
  }
  var width = attributes.width,
    widthType = attributes.widthType,
    layout = attributes.layout,
    snapType = attributes.snapType,
    parentNode = attributes.parentNode;
  var actionSubject = type === 'embed' ? ACTION_SUBJECT.EMBEDS : ACTION_SUBJECT.MEDIA_SINGLE;
  return {
    action: ACTION.EDITED,
    actionSubject: actionSubject,
    actionSubjectId: ACTION_SUBJECT_ID.RESIZED,
    attributes: {
      width: width,
      layout: layout,
      widthType: widthType,
      snapType: snapType,
      parentNode: parentNode
    },
    eventType: EVENT_TYPE.UI
  };
};